import HttpHelpers from './helpers';

const LookupsApiEndpoints = {
  getCountries: () => HttpHelpers.unAuthenticatedAxios
    .get('/api/v1/lookups/countries')
    .then((response) => response.data),
};

export default LookupsApiEndpoints;
